<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>ShiftGrip: VR Dynamic Passive Haptic Device</h1>
        </div>
        <div class="picture">
          <img src="../assets/project18_3.png.webp" />
        </div>
        <div class="paper_published">
          Related achievements have been filed as an invention patent: A handheld haptic feedback device and weight simulation method for virtual reality, CN118012260A
        </div>
        <div class="abstract">
          A key challenge in VR haptics is achieving one-to-many haptic mapping: reducing hardware cost by using fewer and simpler devices to simulate more types of haptic sensations while still maintaining sufficient realism.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_1.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_2.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_4.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_5.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project18",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.abstract {
  margin-top: 26px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
